import React from 'react';
import styled, { css } from 'styled-components';
import HpBar from './HpBar';

import { colors } from '../constant';
import { numberWithCommas } from '../methods';
import { respondTo } from '../responsive';

const Header = ({
    name, status,
    type, pm_name, owner, client, start_date, end_date, budget, serial_number,
    nowUsedHour, canUseHour, cost_sum,
    onClick
}) => {
    return (
        <MainContainer onClick={onClick}>

            <TitleHeader>
                <StatusBadge status={status}>{ status }</StatusBadge>
                <Title>
                    <div>{ serial_number }</div>
                    <span>{ name }</span>
                    <span>{ client }</span>
                </Title>
                <HpBar value={nowUsedHour} total={canUseHour}/>
            </TitleHeader>

            <SubHeader>
                <SubInfoItem label="類型">{ type }</SubInfoItem>
                <SubInfoItem label="負責人">{ owner }</SubInfoItem>
                <SubInfoItem label="PM">{ pm_name }</SubInfoItem>
                {/* <SubInfoItem label="客戶">{ client }</SubInfoItem> */}
                <SplitLine/>
                <SubInfoItem label="預算">{ budget ? `$ ${numberWithCommas(budget || 0)}` : '-' }</SubInfoItem>
                <SubInfoItem label="時程">{`${start_date} - ${end_date}`}</SubInfoItem>
            </SubHeader>

        </MainContainer>
    )
}

const MainContainer = styled.div`
    cursor: pointer;
`

const TitleHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    ${ respondTo.lg } {
        flex-direction: column;
        align-items: flex-start;
    }
`

const StatusBadge = styled.div`
    padding: 0 16px;
    height: 24px;
    background-color: ${ colors.bgDisabled };
    margin-right: 24px;
    
    color: ${colors.text};
    font-size: 12px;
    font-weight: bold;
    border-radius: 14px 4px 24px 14px;
    line-height: 24px;

    ${({status}) => (status === '進行中') && css`
        background-color: ${ colors.primaryGradien };
        color: white;
    `}

    ${({status}) => (status === '提案中' || status === '會持續存在的項目') && css`
        background-color: ${ colors.lightPrimaryGradien };
        color: ${ colors.text };
    `}

    ${ respondTo.lg } {
        margin-right: 0;
        margin-bottom: 8px;
    }
`

const Title = styled.h2`
    color: ${ colors.text };
    font-size: 22px;
    font-weight: bold;
    margin: 0;
    flex: 1;
    max-width: 100%;

    /* display: flex; */
    /* align-items: center; */

    >div:nth-child(1) {
        font-size: 14px;
        font-weight: 400;
        color: ${ colors.label2 };
        margin-bottom: 4px;
    }

    >span:nth-child(3) {
        font-size: 0.7em;
        font-weight: 400;
        margin-left: 16px;
        color: ${ colors.label1 };
    }

    ${ respondTo.lg } {
        width: 100%;
        position: relative;

        >div:nth-child(1) {
            position: absolute;
            text-align: right;
            width: 100%;
            transform: translateY(-200%);
        }
    }

    ${ respondTo.md } {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;
        
        >span:nth-child(2) {
            display: inline-block;
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-bottom: 8px;
            font-size: 16px;
        }

        >span:nth-child(3) {
            margin-left: 0;
            font-size: 12px;
        }
    }
`

const SubHeader = styled.div`
    display: flex;
    align-items: center;
    >* {
        margin-right: 40px;
    }

    ${ respondTo.lg } {
        flex-wrap: wrap;
    }
`

const SubInfoItem = styled.span`
    font-size: 16px;
    font-weight: bold;
    color: ${ colors.text };
    min-width: 104px;

    &::before {
        content: '${({label}) => label}';
        font-size: 14px;
        font-weight: 400;
        color: ${ colors.label2 };
        margin-right: 8px;
    }
    
    ${ respondTo.md } {
        font-size: 12px;
        &::before {
            font-size: 12px;
        }
    }
`

const SplitLine = styled.span`
    display: inline-block;
    height: 16px;
    width: 1px;
    /* background-color: ${ colors.label1 }; */
    flex: 1;

    ${ respondTo.lg } {
        height: 1px;
        width: 100%;
        flex-basis: 80%;
        margin: 8px 0;
        margin-right: 20%;
        background-color: ${ colors.stroke };
    }
`

export default Header;
